import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_112_stock: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    // fabAction: {
    //   type: "add",
    //   screenId: "4",
    //   action: "modulev1/labour_others_add",
    // },
    title: "Stock Balance",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "item_name",
            Form: {
              Name: "stock",
              TableName: "inventory",
              Query:
                "SELECT part_no, item_name, purchase_rate, sale_rate, stock, CASE WHEN stock <= 0 THEN 'Out of Stock' ELSE 'In Stock' END AS STATUS FROM inventory INNER JOIN item_master ON item_master.id = inventory.product_id",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "Code",
                  BindValue: "code_number",
                  Json_Attribute: "part_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Part name",
                  IsMandatory: true,
                  BindValue: "item_name",
                  Json_Attribute: "item_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Purchase rate",
                  IsMandatory: true,
                  BindValue: "purchase_rate",
                  Json_Attribute: "purchase_rate",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Sale rate",
                  IsMandatory: true,
                  BindValue: "sale_rate",
                  Json_Attribute: "sale_rate",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Stock Balance",
                  IsMandatory: true,
                  BindValue: "stock",
                  Json_Attribute: "stock",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Status",
                  IsMandatory: true,
                  BindValue: "status",
                  Json_Attribute: "STATUS",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  ChangeTextColor: true,
                  Text_class_fail: "text-danger",
                  Text_class_success: "text-success",
                  TextColorCondition: "Out of Stock",
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
